export default "__VITE_ASSET__TjHQVuTb__"